import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import CategoryView from './components/CategoryView';
import StratagemView from './components/StratagemView';
import CategoryList from './components/CategoryList';
import AdminLogin from './components/AdminLogin';
import ChunkEditor from './components/ChunkEditor';
import { fetchApi } from './utils/api';
import backgroundImage from './assets/background.jpg';
import './App.css';  // Import the CSS file

function Home() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await fetchApi('/categories');
        setCategories(data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  const handleCategoryClick = (categoryId) => {
    navigate(`/category/${categoryId}`);
  };

  if (loading) return <div className="section"><p className="subtitle">Loading categories...</p></div>;
  if (error) return <div className="section"><p className="subtitle has-text-danger">Error: {error}</p></div>;
  if (!categories || categories.length === 0) return <div className="section"><p className="subtitle">No categories found</p></div>;

  return (
    <div className="section">
      <h2 className="title is-2 mb-4">Categories</h2>
      <div className="columns is-multiline">
        {categories.map(category => (
          <div key={category.id} className="column is-one-third">
            <div className="card" onClick={() => handleCategoryClick(category.id)}>
              <div className="card-content">
                <p className="title is-4">{category.name}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="app-wrapper" style={{
        background: `linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="app-container">
          <h1 className="title is-1 has-text-centered mt-4 mb-6">Verbal Stratagems</h1>
          <Routes>
            <Route path="/" element={<CategoryList />} />
            <Route path="/category/:id" element={<CategoryView />} />
            <Route path="/stratagem/:id" element={<StratagemView />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/stratagem/:id" element={<ChunkEditor />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App; 